// Centralized defaults for user-facing placeholder images.
// These live in /public/pictures so they can be swapped by replacing the files.

export const DEFAULT_MAIN_PICTURE = "/pictures/main.png";
export const DEFAULT_AVATAR_PICTURE = "/pictures/avatar.png";



